import { TranslateService } from '@ngx-translate/core';

import { RawString, TranslationParams, TranslationTokens } from '@ideals/models';

// Re-exported so `@ideals/components/translate` stays the one-stop import for UI code.
// The types themselves live in `@ideals/models` so that layer never has to point back at the UI library.
export type { RawString, TranslationParams, TranslationToken, TranslationTokens } from '@ideals/models';

export function translate(translateService: TranslateService, tokens: TranslationTokens): string {
  const items = Array.isArray(tokens) ? tokens.flat() : [tokens];
  const strings: string[] = [];

  for (let i = 0; i < items.length; i++) {
    const key = items[i];

    if (typeof key === 'string') {
      const nextItem = items[i + 1];
      const params = typeof nextItem === 'string' || isRawString(nextItem) ? undefined : nextItem;

      strings.push(translateService.instant(key, params) as string);

      if (params) {
        i++;
      }
    } else if (isRawString(key)) {
      strings.push(key.raw);
    }
  }

  return strings.join('');
}

function isRawString(value: RawString | TranslationParams): value is RawString {
  return typeof value === 'object' && 'raw' in value;
}
